var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTotalAllotments(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 42,
    viewBox: "0 0 45 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 42,
    rx: 21,
    fill: "#FFF5F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6667 21.4167V16.6667C29.6667 15.2666 29.6667 14.5666 29.3942 14.0318C29.1545 13.5614 28.7721 13.1789 28.3017 12.9392C27.7669 12.6667 27.0668 12.6667 25.6667 12.6667H20.3334C18.9332 12.6667 18.2332 12.6667 17.6984 12.9392C17.228 13.1789 16.8455 13.5614 16.6059 14.0318C16.3334 14.5666 16.3334 15.2666 16.3334 16.6667V25.3334C16.3334 26.7335 16.3334 27.4336 16.6059 27.9684C16.8455 28.4388 17.228 28.8212 17.6984 29.0609C18.2332 29.3334 18.9332 29.3334 20.3334 29.3334H23M24.6667 20.1667H19.6667M21.3334 23.5001H19.6667M26.3334 16.8334H19.6667M25.0834 26.8334L26.75 28.5001L30.5 24.7501",
    stroke: "#EE46BC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalAllotments);
export default __webpack_public_path__ + "static/media/totalAllotments.9b83e13e2696a5fd465fd419738d74f0.svg";
export { ForwardRef as ReactComponent };